import React from "react";
import { shallowEqual, useSelector } from "react-redux";

import { MessageTypes } from "../../lib/types";

import InteractiveUserMessage from "../messages/InteractiveUserMessage";
import UserMessage from "../messages/UserMessage";
import NewSessionMessage from "../NewSessionMessage";
import { getMessagesHistory } from "../../store";
import { getEditingMessageNum, getWorkWithHistory } from "../messages/selectors";
import { getIsIAactive } from "../InstantAnswers/selectors";
import { BotMessageGenerator } from "../messages/BotMessageGenerator";

/**
 * Render messages.
 * @returns {*}
 */
export const Messages = () => {
  const messagesHistory = useSelector(getMessagesHistory, shallowEqual);
  const editingMode = useSelector(getWorkWithHistory, shallowEqual);
  const editingMessageNum = useSelector(getEditingMessageNum, shallowEqual);
  const isIAactive = useSelector(getIsIAactive, shallowEqual);

  /**
   * Render bot's message.
   * @param messageData - message data.
   * @param messageNum - just a number of the message.
   * @param isLastMessage - is it the last rendered message.
   * @param key - react key
   * @returns {*}
   */
  const renderBotMessage = (messageData, messageNum, isLastMessage, key) => {
    return (
      <BotMessageGenerator key={key} isLastMessage={isLastMessage} messageNum={messageNum} messageData={messageData} />
    );
  };

  return messagesHistory.map((message, i) => {
    // In the editing mode render only the previous message (the one with the question).
    if (editingMode && ![i, i + 1].includes(editingMessageNum)) {
      return null;
    }
    // Is it the last rendered message.
    let isLast = i === messagesHistory.length - 1;
    // UPD: not necessarily means actually last message anymore.
    // If it is the second from the end and the next one is the IA_FEEDBACK_MESSAGE - count this as the last too.
    // That's fucked up, yup.
    if (i === messagesHistory.length - 2 && messagesHistory[i + 1].type === MessageTypes.IA_FEEDBACK_MESSAGE) {
      isLast = true;
    }
    const key = `${message.type}-${i}`;

    // Render only IA messages in IA mode.
    if (isIAactive) {
      switch (message.type) {
        case MessageTypes.IA_BOT_MESSAGE:
          return renderBotMessage(message, i, isLast, key);
        case MessageTypes.IA_FEEDBACK_MESSAGE:
          return renderBotMessage(message, i, isLast, key);
        case MessageTypes.IA_USER_MESSAGE:
          return <UserMessage key={key} {...message} messageNum={i} />;
        default:
          return null;
      }
    } else {
      // Render all messages if not in IA mode.
      if (
        [
          MessageTypes.BOT_MESSAGE,
          MessageTypes.EXTRA_BOT_MESSAGE,
          MessageTypes.IA_BOT_MESSAGE,
          MessageTypes.LOCATIONS_MESSAGE,
          MessageTypes.ERROR_MESSAGE,
          // MessageTypes.IA_FEEDBACK_MESSAGE,  // Don't render the feedback in the regular mode.
        ].includes(message.type)
      ) {
        return renderBotMessage(message, i, isLast, key);
      }
      if ([MessageTypes.USER_MESSAGE, MessageTypes.IA_USER_MESSAGE].includes(message.type)) {
        return <UserMessage key={key} {...message} messageNum={i} />;
      }
      if (message.type === MessageTypes.INTERACTIVE_USER_MESSAGE) {
        return <InteractiveUserMessage key={key} {...message} messageNum={i} />;
      }
      return <NewSessionMessage key={key} {...message} />;
    }
  });
};
